import React from "react";
import {Helmet} from "react-helmet";
export const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        {process.env.REACT_APP_ENV==='prod' ? <meta name="robots" content="index,follow"></meta> : <meta name="robots" content="noindex,nofollow"></meta>  }
      </Helmet>
      <main>{children}</main>
      </>
  )
}
